<template>
    <div class="app-cont">
        <header-component />
        <router-view v-if="isMounted" />
        <div class="conditions__loader-container" v-if="isLoading">
            <loader :size="'large'" :type="'infinite-spinner'"></loader>
        </div>
        <floating-file-notes-button />
    </div>
</template>

<script>
    import { Loader } from "@progress/kendo-vue-indicators";

    import header from './components/header.vue';
    import FloatingFileNotesButton from './components/FloatingFileNotesButton.vue';

    import auth from './authConfig.js';

    var emitter = require('tiny-emitter/instance');
    export default {
   
   
        data() {
            return {
                isLoading: true,
                isMounted: false,
            
            }
        },
       async created() {
    
          const msalAppInstance = await auth.init();

         msalAppInstance.handleRedirectPromise().then(async (tokenRes) => {
            this.fetchData();
          });
 
    },
    methods: {
  
      async fetchData() {
        let sessionLoanId = sessionStorage.getItem('selectedloan');
        let loanIdParam = this.$route.query.id;

        if (!sessionLoanId) {
          sessionStorage.setItem('selectedloan', loanIdParam);
          this.isMounted = true;
          this.isLoading = false;
        } else {
          if (loanIdParam) {
            if (loanIdParam !== sessionLoanId) {

              sessionStorage.setItem('selectedloan', loanIdParam);

              await this.$store.dispatch('updateLoan');
              await this.$store.dispatch('getConditions');
              await this.$store.dispatch('getAttachments');
              await this.$store.dispatch('getDocuments');
            }

            this.isMounted = true;
            this.isLoading = false;
          }
        }
      }
    },
        components: {
            'header-component': header,
            'loader': Loader,
            'floating-file-notes-button': FloatingFileNotesButton
        } 
    }
</script>

<style>
    @import '../src/assets/css/cgslight.css';
    @import '../src/assets/css/site.css';

    #app {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
        height: 100vh;
    }

    nav {
        padding: 30px;
    }

    nav a {
        font-weight: bold;
        color: #2c3e50;
    }

    nav a.router-link-exact-active {
        color: #42b983;
    }

    .app-cont {
        height: 100%;
    }

    @media only screen and (max-width: 500px) and (orientation: portrait) {
      #app {
        height: unset;
      }
    }
</style>
